import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { toFloatAsString } from "../../internal/utils/toFloatAsString.js";
/**
 * @description Class for creating a preview of a video
 * @memberOf Actions.VideoEdit
 * @extends SDK.Action
 * @see Visit {@link Actions.VideoEdit|VideoEdit} for an example
 */

var PreviewAction = /*#__PURE__*/function (_Action) {
  _inherits(PreviewAction, _Action);

  var _super = _createSuper(PreviewAction);

  function PreviewAction() {
    var _this;

    _classCallCheck(this, PreviewAction);

    _this = _super.call(this);
    _this._actionModel = {
      actionType: 'preview'
    };
    return _this;
  }
  /**
   * @description Control the duration of the video segments
   * @param {string|number} minSegDuration The duration of a video segment
   * @return {this}
   */


  _createClass(PreviewAction, [{
    key: "minimumSegmentDuration",
    value: function minimumSegmentDuration(minSegDuration) {
      this._actionModel.minimumSegmentDuration = +minSegDuration;
      this._minSeg = minSegDuration;
      return this;
    }
    /**
     * @description Control the number of the video segments
     * @param {string|number} maxSeg The number of the video segments.
     * @return {this}
     */

  }, {
    key: "maximumSegments",
    value: function maximumSegments(maxSeg) {
      this._actionModel.maximumSegments = +maxSeg;
      this._maxSeg = maxSeg;
      return this;
    }
    /**
     * @description control the length of the generated preview
     * @param {string|number} duration The duration in seconds such as 1.2, or 5.0
     * @return {this}
     */

  }, {
    key: "duration",
    value: function duration(_duration) {
      this._actionModel.duration = +_duration;
      this._duration = _duration;
      return this;
    }
  }, {
    key: "toString",
    value: function toString() {
      return ['e_preview', this._duration && "duration_".concat(toFloatAsString(this._duration)), this._maxSeg && "max_seg_".concat(this._maxSeg), this._minSeg && "min_seg_dur_".concat(toFloatAsString(this._minSeg))].filter(function (a) {
        return a;
      }).join(':');
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var duration = actionModel.duration,
          maximumSegments = actionModel.maximumSegments,
          minimumSegmentDuration = actionModel.minimumSegmentDuration; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this();

      if (duration != null) {
        result.duration(duration);
      }

      if (maximumSegments != null) {
        result.maximumSegments(maximumSegments);
      }

      if (minimumSegmentDuration != null) {
        result.minimumSegmentDuration(minimumSegmentDuration);
      }

      return result;
    }
  }]);

  return PreviewAction;
}(Action);

export { PreviewAction };